import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ProjectVersion } from 'src/app/constants/project-version-constans';
import { CurrencyEnums } from 'src/app/enum/currency-enums';
import { ElectronicDocumentEnums } from 'src/app/enum/electronic-document-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { FormatDetailModel } from 'src/app/models/formats/format-detail.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { NotePrintModel } from 'src/app/models/invoicing/note-print.model';
import { EnterpriseModel } from 'src/app/models/management/enterprise.model';
import { FormatDetailService } from 'src/app/services/formats/format-detail.service';
import { PrintPageSizeService } from 'src/app/services/global-services/print-page-size.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { ValuesInLettersService } from 'src/app/services/global-services/values-in-letters.service';
import { NoteConceptService } from 'src/app/services/invoicing/note-concept.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { GeneralParameterService } from 'src/app/services/management/general-parameter.service';

interface GroupMetadata {
  baseIva: number;
  reteFuente: number;
  reteIca: number;
  rateBaseIva: number;
}
@Component({
  selector: 'app-print-note',
  templateUrl: './print-note.component.html',
  styleUrls: ['./print-note.component.scss'],
  standalone: false
})
export class PrintNoteComponent implements OnInit {

  @Input() companyId: number | null = 0;
  @Input() editFormat: boolean = false;
  @Input() exportFormat: boolean = false;
  @Input() isLevelArticle: boolean = false;
  @Input() formatModel: FormatModel = new FormatModel();
  @Input() notePrintModel: NotePrintModel = new NotePrintModel();
  @Input() focusText: boolean = false;
  @Input() formatDetail: FormatDetailModel = new FormatDetailModel();
  @Input() electronicInvoiceInterface: boolean = false;
  @Output() emitFormatDetail = new EventEmitter<FormatDetailModel>();
  @Output() finishLoadingPrint = new EventEmitter<boolean>();
  @Output() finishLoadingPrintNote = new EventEmitter<boolean>();

  // Variables para mover elementos
  bottomPreview: number = 0;
  element: any;
  elementStyle: any;
  elementsBody: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  elementsLabel: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  id = '';
  isShift = false;
  leftPreview: number = 0;
  mouseDown: boolean = false;
  newFormatDetail: FormatDetailModel = new FormatDetailModel();
  rightPreview: number = 0;
  shiftX: number = 0;
  shiftY: number = 0;
  speed = 2;
  styleQr: FormatDetailModel = new FormatDetailModel();
  version: string = ProjectVersion.projectVersion;

  // Tabla Nueva
  groupDataMap: { [key: string]: GroupMetadata } = {};
  columns: { field: string; header: string; }[] = [];
  idMap: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat: string | null; } } = {
    'codeNameConceptInvoicing': { id: 'concepto', type: 'number', showTotal: false, printFormat: null },
    'invoicedValueConcept': { id: 'valor-concepto', type: 'decimal', showTotal: false, printFormat: null },
    'articleCode': { id: 'articulo', type: 'text', showTotal: false, printFormat: null },
    'articleName': { id: 'articulo-nombre', type: 'text', showTotal: false, printFormat: null },
    'familyCode': { id: 'familia', type: 'text', showTotal: false, printFormat: null },
    'groupCode': { id: 'grupo', type: 'text', showTotal: false, printFormat: null },
    'subgroupCode': { id: 'subgrupo', type: 'text', showTotal: false, printFormat: null },
    'totalTime': { id: 'dias', type: 'decimal', showTotal: false, printFormat: null },
    'unitValue': { id: 'valor-unitario', type: 'decimal', showTotal: false, printFormat: null },
    'ivaRate': { id: 'impuesto', type: 'decimal', showTotal: false, printFormat: null },
    'taxValue': { id: 'valor-impuesto', type: 'decimal', showTotal: false, printFormat: null },
    'quantity': { id: 'cantidad', type: 'decimal', showTotal: false, printFormat: null },
    'totalValue': { id: 'valor-total', type: 'decimal', showTotal: false, printFormat: null },
  };

  currencyLocal: number = CurrencyEnums.monedaLocal;
  dateNow: Date = new Date();
  enterpriseModel: EnterpriseModel | null = null;
  generalParametersId: Array<number> = new Array<number>();
  listConceptInvoicing: Array<ItemFilterModel> = new Array<ItemFilterModel>();
  listFormatDetailUpdates: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  logoEnterprise: SafeUrl = '';
  logoFooterEnterprise: SafeUrl = '';
  paperSizeFormat: number = 0;
  reteIca: boolean = false;
  reteIva: boolean = false;
  retefuente: boolean = false;
  signatureEnterprise: SafeUrl = '';
  swElectronicInvoice: boolean = false;
  textBaseIva: string = '';
  textTarifaIva: string = '';
  topPreview: number = 0;
  typeDianInvoiceExport: number = ElectronicDocumentEnums.tipoDianFacturaExportacion;
  userAuthenticated: string = '';

  private keydownListener!: (e: KeyboardEvent) => void;
  private mouseupListener!: () => void;
  private mousemoveListener!: (e: MouseEvent) => void;
  private keyupListener!: (e: KeyboardEvent) => void;

  constructor(private enterpriseService: EnterpriseService,
    private formatDetailService: FormatDetailService,
    private generalParameterService: GeneralParameterService,
    private noteConceptService: NoteConceptService,
    private sanitizer: DomSanitizer,
    private userAuthenticatedService: UserAuthenticatedService,
    private valuesInLettersService: ValuesInLettersService,
    private printPageSizeService: PrintPageSizeService) { }

  async ngOnInit() {
    await this.getUserAutheticated();
    if (this.companyId != 0) await this.getGeneralParameter();
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const formatModel = changes["formatModel"];
    const notePrintModel = changes["notePrintModel"];
    const exportFormat = changes["exportFormat"];
    const formatDetail = changes["formatDetail"];
    if (exportFormat && !exportFormat.firstChange) { this.updateRangeFormatDetail(); }
    if (formatModel && formatModel.firstChange) this.formatModel = formatModel.currentValue;
    if (notePrintModel && !notePrintModel.firstChange) {
      if (this.notePrintModel) {
        await Promise.all([
          this.getEnterpriseById(this.notePrintModel.enterpriseId)
        ]);
      }
    }
    if (formatDetail && !formatDetail.firstChange) this.changeFormatDetail();
  }

  ngOnDestroy() {
    this.printPageSizeService.removePageSizeStyle();

    // Remover event listeners globales
    if (this.keydownListener) document.removeEventListener('keydown', this.keydownListener);
    if (this.mouseupListener) document.removeEventListener('mouseup', this.mouseupListener, true);
    if (this.mousemoveListener) document.removeEventListener('mousemove', this.mousemoveListener, true);
    if (this.keyupListener) document.removeEventListener('keyup', this.keyupListener);
  }

  ngAfterViewInit() {
    if (this.editFormat) {
      this.keydownListener = (e: KeyboardEvent) => {
        const target = e.target as HTMLElement;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.tagName === 'SELECT' ||
            target.isContentEditable)
        ) {
          return;
        }
        // 2. Si no hay ningún elemento seleccionado para mover, no bloquear
        if (!this.element) {
          return;
        }

        // Deshabilita desplazamiento del scroll con la tecla espacio y flechas
        if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
          this.blockScrollArrows(e);
        }

        if (e.which == 16) this.isShift = true;
        //Mover element con flechas
        if (!this.isShift) {
          switch (e.key) {
            case 'ArrowLeft': { this.moveLeft(); break; }
            case 'ArrowRight': { this.moveRight(); break; }
            case 'ArrowUp': { this.moveUp(); break; }
            case 'ArrowDown': { this.moveDown(); break; }
          }
        }

        //Modificar element tamaño de objeto
        if (this.isShift) {
          switch (e.which) {
            case 37: { this.decreaseWidth(); break; }
            case 38: { this.decreaseHeight(); break; }
            case 39: { this.increaseWidth(); break; }
            case 40: { this.increaseHeight(); break; }
          }
        }
      };

      this.mouseupListener = () => {
        this.onMouseUp();
      };

      this.mousemoveListener = (e: MouseEvent) => {
        this.onMouseMove(e);
      };

      this.keyupListener = (e: KeyboardEvent) => {
        if (e.which == 16) this.isShift = false;
      };

      // Registrar los listeners en el document
      document.addEventListener('keydown', this.keydownListener);
      document.addEventListener('mouseup', this.mouseupListener, true);
      document.addEventListener('mousemove', this.mousemoveListener, true);
      document.addEventListener('keyup', this.keyupListener);
    }
  }

  private adjustElementSize(property: 'height' | 'width', delta: number) {
    if (this.focusText) return;

    const currentValue = this.elementStyle.getPropertyValue(property);
    const numericValue = parseFloat(currentValue.replace('px', ''));

    const newValue = numericValue + delta;
    this.element.style[property] = `${newValue}px`;

    this.onClick();
  }

  private async applyColumnStyles(note: NotePrintModel) {
    for (const column of this.columns.map(x => x.field)) {
      const element = this.elementsBody.find(x => x.description === column);
      if (!element) continue;

      this.element = document.getElementById(`${element.name}-${note.noteId}`);
      if (this.element) {
        this.element.style.fontSize = `${element.fontSize}px`;
        this.element.style.width = `${element.width}%`;
        await this.changeAlignment(element.alignment);
      }
    }
  }

  private applyElementStyles(element: FormatDetailModel) {
    if (!element.visible) {
      this.element!.setAttribute('hidden', '');
      return;
    }

    const style = this.element!.style;
    style.fontSize = `${element.fontSize}px`;
    this.changeAlignment(element.alignment);
    this.changeBold(element.bold);
    this.changeBorder(element.border);

    if (element.name.includes('foot-')) {
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    } else {
      style.backgroundColor = 'transparent';
      style.position = 'absolute';
      style.left = `${element.left}%`;
      style.top = `${element.top}%`;
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    }
  }

  private async applyFormatDetails(elements: FormatDetailModel[], note: NotePrintModel) {
    for (const element of elements) {
      if (element.band === 'body') continue;

      if (element.name.includes('foot-group')) {
        setTimeout(() => { this.groupingClasses(element); }, 200);
      } else if (element.name === 'qr') {
        if (this.swElectronicInvoice && note.cufe) {
          this.styleQr = element;
        }
      } else {
        this.element = document.getElementById(`${element.name}-${note.noteId}`);
        if (this.element) {
          this.applyElementStyles(element);
        }
      }
    }
  }

  private updateElementWidth(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) return;
    this.element.style.width = `${this.formatDetail.width}%`;
  }


  private applyFormatStyles(element: HTMLElement) {
    element.style.fontSize = `${this.formatDetail.fontSize}px`;
    this.changeAlignment(this.formatDetail.alignment);
    this.changeBold(this.formatDetail.bold);
    this.changeBorder(this.formatDetail.border);

    if (!this.formatDetail.name.includes('foot-')) {
      element.style.position = 'absolute';
      element.style.left = `${this.formatDetail.left}%`;
      element.style.top = `${this.formatDetail.top}%`;
    }

    element.style.height = `${this.formatDetail.height}px`;
    element.style.width = `${this.formatDetail.width}px`;
  }

  private applyParagraphStyles(note: NotePrintModel) {
    this.elementsBody
      .filter(x => x.type === 'p')
      .forEach(element => {
        note.noteDetails.forEach(detail => {
          this.element = document.getElementById(`${element.name}-${detail.noteDetailId}`);
          if (this.element) {
            this.element.style.fontSize = `${element.fontSize}px`;
            this.changeAlignment(element.alignment);
            this.changeBold(element.bold);
          }
        });
      });
  }

  private applyHeaderFooterHeights(noteId: number, formatModel: FormatModel) {
    const head = document.getElementById(`head-${noteId}`);
    const foot = document.getElementById(`foot-${noteId}`);
    head!.style.height = `${formatModel.head}px`;
    foot!.style.height = `${formatModel.foot}px`;
    this.paperSizeFormat = formatModel.paperSizeId
  }

  blockScrollArrows(e: any) {
    if (!this.focusText) {
      e.preventDefault();
    }
  }

  private buildDisplayedColumns(note: NotePrintModel) {
    this.columns = [];
    this.elementsBody.filter(x => x.type === 'label').forEach(element => {
      if (note.bussinessDocumentsDianTypeId !== this.typeDianInvoiceExport ||
        (element.description !== 'tax' && element.description !== 'valueTax')) {
        this.columns.push({ field: element.description!, header: element.text! });
        this.idMap[element.description!].printFormat = element.printFormat ?? null;
      }
    });
  }

  async changeAlignment(alignment: string) {
    this.element.style.textAlign = alignment;
  }

  changeBold(bold: string) {
    this.element.style.fontWeight = bold;
  }

  changeBorder(border: string) {
    switch (border) {
      case 'noborder': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        break;
      }
      case 'border': {
        this.element.style.border = '1px solid rgb(0, 0, 0)';
        break;
      }
      case 'underline': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        this.element.style.borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }
  }

  changeFormatDetail() {
    const formatId = this.formatDetail.formatDetailId;
    if (formatId == 0) return;

    const isBody = this.formatDetail.band === 'body';
    const isLabel = this.formatDetail.type === 'label';

    if (isBody) {
      const element = this.elementsBody.find(x => x.formatDetailId === formatId);
      if (!element) return;

      element.alignment = this.formatDetail.alignment;
      element.fontSize = this.formatDetail.fontSize;

      if (isLabel) {
        element.visible = this.formatDetail.visible;
        element.width = this.formatDetail.width;
        element.text = this.formatDetail.text;
        element.printFormat = this.formatDetail.printFormat;

        if (!this.formatDetail.visible) {
          this.columns = this.columns.filter(x => x.field !== element.description);
        } else {
          this.updateElementWidth(this.formatDetail.name, this.notePrintModel.noteId);
          this.updateElementStyle(this.formatDetail.name, this.notePrintModel.noteId);
          this.changeAlignment(this.formatDetail.alignment);
        }
      } else {
        element.bold = this.formatDetail.bold;
        this.notePrintModel.noteDetails.forEach(detail => {
          if (detail.noteDetailId) {
            this.updateElementStyle(this.formatDetail.name, detail.noteDetailId);
            this.changeAlignment(this.formatDetail.alignment);
            this.changeBold(this.formatDetail.bold);
          }
        });
      }
      this.elementsBody = this.elementsBody.filter(x => x.formatDetailId !== formatId);
      this.elementsBody.push(element);
      const fieldName = element.description;
      if (fieldName && this.idMap[fieldName]) {
        this.idMap[fieldName].printFormat = element.printFormat;
      }
    } else {
      if (this.formatDetail.name.includes('foot-group')) {
        this.groupingClasses(this.formatDetail);
      } else {
        this.updateElementStyle(this.formatDetail.name, this.notePrintModel.noteId);

        if (!this.formatDetail.visible) {
          this.element.setAttribute('hidden', '');
        } else {
          this.applyFormatStyles(this.element);
          this.updateLabelText(formatId, this.formatDetail.text!);
          this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== formatId);
          this.listFormatDetailUpdates.push(this.formatDetail);
        }
      }
      const labelElement = this.elementsLabel.find(x => x.name === this.formatDetail.name);
      if (labelElement) {
        labelElement.printFormat = this.formatDetail.printFormat;
        this.elementsLabel = [...this.elementsLabel];
      }
    }
  }

  async chargeFormat(formatModel: FormatModel): Promise<boolean> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolved) => {
      this.formatModel = formatModel;
      this.printPageSizeService.setPageSizeStyle(formatModel.paperSizeId);

      this.applyHeaderFooterHeights(this.notePrintModel.noteId, formatModel);
      this.paperSizeFormat = formatModel.paperSizeId;
      this.extractFormatDetails(formatModel);

      this.buildDisplayedColumns(this.notePrintModel);

      await this.applyFormatDetails(formatModel.formatDetails, this.notePrintModel);

      if (this.swElectronicInvoice && this.notePrintModel.cude) {
        await this.chargeFormatQr(this.notePrintModel.noteId);
      }

      setTimeout(async () => {
        await this.applyColumnStyles(this.notePrintModel);
        this.applyParagraphStyles(this.notePrintModel);
        resolved(true);
      }, 200);
    });
  }

  private async chargeFormatQr(noteId: number) {
    const elements = document.querySelector(`[title="qr-${noteId}"]`);
    this.element = elements;
    this.element.id = `qr-${noteId}`;
    if (!this.styleQr.visible) {
      this.element.setAttribute('hidden', '');
    } else {
      this.element.style.position = 'absolute';
      this.element.style.fontSize = `${this.styleQr.fontSize}px`;
      this.changeAlignment(this.styleQr.alignment);
      this.changeBold(this.styleQr.bold);
      this.changeBorder(this.styleQr.border);
      this.element.style.left = `${this.styleQr.left}%`;
      this.element.style.top = `${this.styleQr.top}%`;
      this.element.style.height = `${this.styleQr.height}px`;
      this.element.style.width = `${this.styleQr.width}px`;
    }
  }

  clickTable(event: any) {
    if (!this.editFormat) return;

    const element = document.getElementById(event.target.id);
    if (!element) return;

    const elementStyle = window.getComputedStyle(element);
    const name = event.target.id.substring(0, event.target.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    const bodyElement = this.elementsBody.find(x => x.name === name);

    if (!formatDetail || !bodyElement) return;

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.type = formatDetail.type;
    this.newFormatDetail.visible = bodyElement.visible;
    this.newFormatDetail.text = bodyElement.text;
    this.newFormatDetail.orderTable = bodyElement.orderTable;
    this.newFormatDetail.printFormat = bodyElement.printFormat;

    // Ancho
    if (formatDetail.type === 'label') {
      const rawWidth = element.style.width;
      const width = parseFloat(rawWidth.replace('%', '')) || 0;
      this.newFormatDetail.width = parseFloat(width.toFixed(4));
    } else {
      this.newFormatDetail.width = 0;
    }

    // Tamaño de fuente
    const fontSize = parseInt(elementStyle.getPropertyValue('font-size').replace('px', ''));
    this.newFormatDetail.fontSize = isNaN(fontSize) ? 0 : fontSize;

    // Negrita
    const fontWeight = elementStyle.getPropertyValue('font-weight');
    this.newFormatDetail.bold = fontWeight === '400' ? 'normal' : 'bold';

    // Alineación
    this.newFormatDetail.alignment = elementStyle.getPropertyValue('text-align');

    this.emitFormatDetail.emit(this.newFormatDetail);
  }

  private processNote(note: NotePrintModel): Promise<void>[] {
    const promises: Promise<void>[] = [];

    // 1. Configuración de flags de retención
    this.retefuente = !note.enterpriseSwSelfRetainer && this.retefuente;
    this.reteIca = !note.enterpriseSwIcaSelfRetainer && this.reteIca;

    // 2. Transformación de datos básicos
    note.totalValueInLetters = this.valuesInLettersService.convertNumberToLetters(note.totalValue, false);

    // 3. Ordenar y Re-indexar detalles por concepto
    note.noteDetails
      .sort((a, b) => (a.conceptInvoicingId ?? 0) - (b.conceptInvoicingId ?? 0))
      .forEach((detail, index) => (detail.index = index + 1));

    // 4. Procesar Grupos si aplica
    if (this.formatModel.group) {
      const conceptPromises = this.getGroupPromises(note);
      promises.push(...conceptPromises);
    }

    return promises;
  }

  private getGroupPromises(note: NotePrintModel): Promise<void>[] {
    const uniqueConceptIds = [...new Set(note.noteDetails.map(d => d.conceptInvoicingId))];

    return uniqueConceptIds.map(async (conceptId) => {
      const groupItems = note.noteDetails.filter(d => d.conceptInvoicingId === conceptId);
      const firstItem = groupItems[0];

      // Ejecución paralela de servicios por concepto
      const [baseIva, reteFuenteVal, reteIcaVal] = await Promise.all([
        firstValueFrom(this.noteConceptService.getIvaRateByNoteAndConcept(note.noteId, conceptId!)),
        this.retefuente ? firstValueFrom(this.noteConceptService.getReteFuenteByNoteAndConcept(note.noteId, conceptId!)) : Promise.resolve({ value: 0 }),
        this.reteIca ? firstValueFrom(this.noteConceptService.getReteIcaByNoteAndConcept(note.noteId, conceptId!)) : Promise.resolve({ value: 0 })
      ]);

      this.groupDataMap[`${note.noteId}_${conceptId}`] = {
        rateBaseIva: firstItem.ivaRate,
        baseIva: baseIva?.value || 0,
        reteFuente: typeof reteFuenteVal === 'number' ? reteFuenteVal : 0,
        reteIca: typeof reteIcaVal === 'number' ? reteIcaVal : 0,
      };
    });
  }

  getLabelPrintFormat(name: string): string | null {
    return this.elementsLabel.find(x => x.name === name)?.printFormat ?? null;
  }

  getGroupInfo(noteId: number, conceptId: number) {
    return this.groupDataMap[`${noteId}_${conceptId}`];
  }

  async configureFormatByNote() {
    const note = this.notePrintModel;
    try {
      const promises = this.processNote(note);

      await Promise.all(promises);
      await this.chargeFormat(this.formatModel);

      this.finishLoadingPrintNote.emit(true);
    } catch (error) {
      console.error("Error en la configuración de nota:", error);
    }
  }

  decreaseHeight() {
    this.adjustElementSize('height', -this.speed);
  }

  decreaseWidth() {
    this.adjustElementSize('width', -this.speed);
  }

  onColumnReorder() {
    this.columns.forEach((col, index) => {
      this.elementsBody.find(x => x.description == col.field)!.orderTable = index;
    });
  }

  private extractFormatDetails(formatModel: FormatModel) {
    this.elementsLabel = formatModel.formatDetails.filter(x => x.type === 'label');
    this.textTarifaIva = formatModel.formatDetails.find(x => x.name === 'foot-group-tarifaIva')?.text ?? '';
    this.textBaseIva = formatModel.formatDetails.find(x => x.name === 'foot-group-baseIva')?.text ?? '';
    const copyFormatModel: FormatModel = JSON.parse(JSON.stringify(formatModel));
    if (this.notePrintModel.isLevelArticle) {
      // Nivel artículo
      copyFormatModel.formatDetails.forEach(element => {
        if (!element) return;
        // Campo 'th-valor-concepto': DEBE OCULTARSE a nivel artículo
        if (element.name === 'th-valor-concepto') {
          element.visible = false;
        }
        // Campos 'th-articulo' y 'th-articulo-nombre': DEBEN MOSTRARSE a nivel artículo
        else if ((element.name === 'th-articulo' || element.name === 'th-articulo-nombre') && element.visible) {
          element.visible = true;
        }
      });
    } else {
      // Nivel concepto:
      copyFormatModel.formatDetails.forEach(element => {
        if (!element) return;

        // Campo 'th-valor-concepto': DEBE MOSTRARSE a nivel concepto
        if (element.name === 'th-valor-concepto' && element.visible) {
          element.visible = true;
        }
        // Campos 'th-articulo' y 'th-articulo-nombre': DEBEN OCULTARSE a nivel concepto
        else if (element.name === 'th-articulo' || element.name === 'th-articulo-nombre') {
          element.visible = false;
        }
      });
    }

    this.elementsBody = copyFormatModel.formatDetails
      .filter(x => x.band === 'body' && x.visible)
      .sort((a, b) => a.orderTable - b.orderTable);
  }

  async getEnterpriseById(enterpriseId: number) {
    const promises = [];
    if (this.enterpriseModel == null) {
      this.enterpriseModel = await firstValueFrom(this.enterpriseService.getEnterpriseById(enterpriseId));
      this.swElectronicInvoice = this.enterpriseModel.swElectronicInvoice;
      if (this.enterpriseModel.logo && this.logoEnterprise == "") promises.push(this.getLogo(this.enterpriseModel));
      if (this.enterpriseModel.logoFooter && this.logoFooterEnterprise == "") promises.push(this.getLogoFooter(this.enterpriseModel));
      if (this.enterpriseModel.signature && this.signatureEnterprise == "") promises.push(this.getSignature(this.enterpriseModel));
      await Promise.all(promises);
    }
    await this.configureFormatByNote();
  }

  async getLogo(enterpriseModel: EnterpriseModel) {
    const blob = await firstValueFrom(this.enterpriseService.getLogo(enterpriseModel));
    if (blob)
      this.logoEnterprise = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
  }

  async getGeneralParameter() {
    //Consulto si tiene retenciones activas
    const response = await firstValueFrom(this.generalParameterService.getGeneralParametersByCompany(this.companyId!));
    this.generalParametersId = response.map(o => o.generalParameterId);
    if (this.generalParametersId.length) {
      const ids = new Set(this.generalParametersId);
      this.reteIva = ids.has(GeneralParameterEnums.reteIvaEnFactura);
      this.retefuente = ids.has(GeneralParameterEnums.retefuenteEnFactura);
      this.reteIca = ids.has(GeneralParameterEnums.reteIcaEnFactura);
    }
  }

  async getSignature(enterpriseModel: EnterpriseModel) {
    const blob = await firstValueFrom(this.enterpriseService.getSignature(enterpriseModel));
    if (blob)
      this.signatureEnterprise = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
  }

  getUserAutheticated() {
    return new Promise((resolve) => {
      this.userAuthenticatedService.userObservable.subscribe(value => {
        this.userAuthenticated = value.userName;
      });
      resolve(true);
    });
  }

  async getLogoFooter(enterpriseModel: EnterpriseModel) {
    const blob = await firstValueFrom(this.enterpriseService.getLogoFooter(enterpriseModel));
    if (blob)
      this.logoFooterEnterprise = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
  }

  private getStylePxValue(property: string): number {
    const value = this.elementStyle.getPropertyValue(property);
    return parseFloat(value.replace('px', '')) || 0;
  }

  private getBorderStyle(): string {
    if (!this.elementStyle) return 'underline';
    const sides = ['top', 'right', 'bottom', 'left'] as const;
    const hasBorder = (side: typeof sides[number]) => {
      const width = this.elementStyle.getPropertyValue(`border-${side}-width`);
      const style = this.elementStyle.getPropertyValue(`border-${side}-style`);
      return style !== 'none' && width !== '0px';
    };
    const borderStates = sides.map(side => hasBorder(side));
    const [top, right, bottom, left] = borderStates;
    if (top || right || left) {
      return 'border';
    } else if (bottom) {
      return 'underline';
    } else {
      return 'noborder';
    }
  }

  async groupingClasses(element: FormatDetailModel) {
    const classMap: { [key: string]: string } = {
      "foot-group-concept": ".group-concept",
      "foot-group-tarifaIva": ".group-tarifaIva",
      "foot-group-baseIva": ".group-baseIva",
      "foot-group-retefuente": ".group-retefuente",
      "foot-group-reteica": ".group-reteica"
    };

    const selector = classMap[element.name];
    if (selector) {
      const classEdit = document.querySelectorAll(selector);
      await this.setGroupingStyles(element, classEdit);
    }
  }

  increaseHeight() {
    this.adjustElementSize('height', this.speed);
  }

  increaseWidth() {
    this.adjustElementSize('width', this.speed);
  }

  isGroup(index: any, item: any): boolean {
    return item.level;
  }

  moveDown() {
    if (!this.focusText) {
      if (this.elementStyle) {
        let elementTop = this.elementStyle.getPropertyValue('top');
        elementTop = elementTop.substring(0, elementTop?.lastIndexOf('px'));
        let top = parseFloat(elementTop);
        top += this.speed;
        const heightPx = parseFloat(this.elementStyle.getPropertyValue('height').substring(0, this.elementStyle.getPropertyValue('height').lastIndexOf('px')));
        if (top + heightPx > this.bottomPreview) top = this.bottomPreview - heightPx;
        const topPercentage = ((top / this.bottomPreview) * 100).toFixed(4);
        this.element.style.top = `${topPercentage}%`;
        this.onClick();
      }
    }
  }

  moveLeft() {
    if (!this.focusText) {
      if (this.elementStyle) {
        let elementLeft = this.elementStyle.getPropertyValue('left');
        elementLeft = elementLeft.substring(0, elementLeft?.lastIndexOf('px'));
        let left = parseFloat(elementLeft);
        left -= this.speed;
        if (left < 0) left = 0;
        const leftPercentage = ((left / this.rightPreview) * 100).toFixed(4);
        this.element.style.left = `${leftPercentage}%`;
        this.onClick();
      }
    }
  }

  moveRight() {
    if (!this.focusText) {
      if (this.elementStyle) {
        let elementLeft = this.elementStyle.getPropertyValue('left');
        elementLeft = elementLeft.substring(0, elementLeft?.lastIndexOf('px'));
        let left = parseFloat(elementLeft);
        left += this.speed;
        const widthPx = parseFloat(this.elementStyle.getPropertyValue('width').substring(0, this.elementStyle.getPropertyValue('width').lastIndexOf('px')));
        if (left + widthPx > this.rightPreview) left = this.rightPreview - widthPx;
        const leftPercentage = ((left / this.rightPreview) * 100).toFixed(4);
        this.element.style.left = `${leftPercentage}%`;
        this.onClick();
      }
    }
  }

  moveUp() {
    if (!this.focusText) {
      if (this.elementStyle) {
        let elementTop = this.elementStyle.getPropertyValue('top');
        elementTop = elementTop.substring(0, elementTop?.lastIndexOf('px'));
        let top = parseFloat(elementTop);
        top -= this.speed;
        if (top < 0) top = 0;
        const topPercentage = ((top / this.bottomPreview) * 100).toFixed(4);
        this.element.style.top = `${topPercentage}%`;
        this.onClick();
      }
    }
  }

  mmToPx(mm: number) {
    const inches = mm / 25.4;
    const px = inches * 101.654;
    return px;
  }

  onClick() {
    if (!this.editFormat) return;

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) return;

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.text = formatDetail.text;
    this.newFormatDetail.visible = true;
    this.newFormatDetail.printFormat = formatDetail.printFormat;

    this.newFormatDetail.fontSize = this.getStylePxValue('font-size');
    this.newFormatDetail.bold = this.elementStyle.getPropertyValue('font-weight') === '400' ? 'normal' : 'bold';
    this.newFormatDetail.alignment = this.elementStyle.getPropertyValue('text-align');
    this.newFormatDetail.border = this.getBorderStyle();

    if (!name.includes('foot-')) {
      this.newFormatDetail.left = parseFloat(((this.getStylePxValue('left') / this.rightPreview) * 100).toFixed(4));
      this.newFormatDetail.top = parseFloat(((this.getStylePxValue('top') / this.bottomPreview) * 100).toFixed(4));
    }

    this.newFormatDetail.width = parseFloat(this.getStylePxValue('width').toFixed(4));
    this.newFormatDetail.height = parseFloat(this.getStylePxValue('height').toFixed(4));

    this.emitFormatDetail.emit(this.newFormatDetail);
    this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== this.newFormatDetail.formatDetailId);
    this.listFormatDetailUpdates.push(this.newFormatDetail);
  }

  onDragStart() {
    return false;
  }

  //Mover objetos con el mouse
  onMouseDown(event: any) {
    if (this.element) {
      this.element.style.backgroundColor = 'transparent'
    }
    this.mouseDown = true;
    this.id = event.target.id;
    this.element = document.getElementById(this.id);
    if (this.element) {
      this.elementStyle = window.getComputedStyle(this.element);
      this.element.style.backgroundColor = '#0d6efd6e'
      const formatDetail = this.formatModel.formatDetails.find(x => x.name == this.id.substring(0, this.id.lastIndexOf('-')));
      const elementRelative = document.getElementById(`${formatDetail!.band}-${this.notePrintModel.noteId}`);
      const elementStyleRelative = window.getComputedStyle(elementRelative!);
      this.leftPreview = Math.round(elementRelative!.offsetLeft - elementRelative!.scrollLeft);
      let elementWidth = elementStyleRelative.getPropertyValue('width');
      elementWidth = elementWidth.substring(0, elementWidth?.lastIndexOf('px'));
      this.rightPreview = parseInt(elementWidth);
      this.topPreview = Math.round(elementRelative!.offsetTop - elementRelative!.scrollTop);
      let elementHeight = elementStyleRelative.getPropertyValue('height');
      elementHeight = elementHeight.substring(0, elementHeight?.lastIndexOf('px'));
      this.bottomPreview = parseInt(elementHeight);

      if (!this.id.includes('foot-')) {//No permito mover elementos totales
        this.element.style.cursor = 'move';
        const leftPX = event.pageX - this.leftPreview;
        const topPX = event.pageY - this.topPreview;
        this.shiftX = leftPX - parseFloat(this.elementStyle.getPropertyValue('left').substring(0,
          this.elementStyle.getPropertyValue('left').lastIndexOf('px')));
        this.shiftY = topPX - parseFloat(this.elementStyle.getPropertyValue('top').substring(0,
          this.elementStyle.getPropertyValue('top').lastIndexOf('px')));
      }

      this.onClick();
    }
  }

  onMouseMove(event: any) {
    if (this.mouseDown) {
      if (!this.element.id.includes('foot-')) { //No permito mover elementos totales
        this.element.style.position = 'absolute';
        let leftPx = event.pageX - this.leftPreview - this.shiftX;
        if (leftPx < 0) {
          leftPx = 0;
        }
        const widthPx = parseFloat(this.elementStyle.getPropertyValue('width').substring(0, this.elementStyle.getPropertyValue('width').lastIndexOf('px')));
        if (leftPx + widthPx > this.rightPreview) {
          leftPx = this.rightPreview - widthPx;
        }
        const leftPercentage = (leftPx / this.rightPreview) * 100;
        this.element.style.left = `${leftPercentage}%`;


        let topPx = event.pageY - this.topPreview - this.shiftY;
        if (topPx < 0) {
          topPx = 0;
        }
        const heightPx = parseFloat(this.elementStyle.getPropertyValue('height').substring(0, this.elementStyle.getPropertyValue('height').lastIndexOf('px')));
        if (topPx + heightPx > this.bottomPreview) {
          topPx = this.bottomPreview - heightPx;
        }
        const topPercentage = (topPx / this.bottomPreview) * 100;
        this.element.style.top = `${topPercentage}%`;
        this.onClick();
      }
    }
  }

  onMouseUp() {
    this.mouseDown = false;
  }

  pxToMm(px: number) {
    const inches = px / 101.654;
    const mm = inches * 25.4;
    return mm;
  }

  async setGroupingStyles(element: FormatDetailModel, classEdit: any) {
    let border: string, borderBottom: string

    switch (element.border) {
      case 'noborder': {
        border = '0px none rgb(0, 0, 0)';
        borderBottom = '';
        break;
      }
      case 'border': {
        border = '1px solid rgb(0, 0, 0)';
        borderBottom = '';
        break;
      }
      case 'underline': {
        border = '0px none rgb(0, 0, 0)';
        borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }

    classEdit.forEach((el: HTMLElement) => {
      el.style.backgroundColor = 'transparent';
      el.style.fontSize = `${element.fontSize}px`;
      el.style.textAlign = element.alignment;
      el.style.fontWeight = element.bold;
      el.style.border = border;
      el.style.borderBottom = borderBottom;
      el.style.height = `${element.height}px`;
      el.style.width = `${element.width}px`;
    });
  }

  private updateLabelText(formatId: number, text: string) {
    const labelElement = this.elementsLabel.find(x => x.formatDetailId === formatId);
    if (labelElement) {
      labelElement.text = text;
    }
  }

  private updateElementStyle(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) return;

    this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
  }

  async updateRangeFormatDetail() {
    this.elementsBody.forEach(element => {
      this.listFormatDetailUpdates.push(element);
    });

    const response = await firstValueFrom(this.formatDetailService.updateRangeFormatDetail(this.listFormatDetailUpdates));
    this.chargeFormat(response);
  }
}